let notificationStack = {
  firstpos1: 25,
  firstpos2: 25,
  push: "top",
  dir1: "up",
  dir2: "up",
};

let notificationModules = {
  Animate: {
    animate: true,
    inClass: "fadeInLeft",
    outClass: "fadeOutLeft",
  },
  Buttons: {
    closer: false,
    sticker: false,
  },
};

window.opts = {
  title: "",
  titleTrusted: true,
  addClass: "custom",
  // text: "Check me out. I'm in a different stack.<span>test</span>",
  // textTrusted: true,
  animation: "fade",
  delay: 5000,
  animateSpeed: "slow",
  icon: false,
  stack: notificationStack,
  modules: notificationModules,
};

$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
  },
});

jQuery(document).ready(function ($) {
  $("img.lazy").lazyload();
  $("iframe").each(function () {
    var $frame = $(this);
    // $frame.attr('src', $frame.attr('src').replace('https:', 'http:'));
  });
  $(".chosen-select").chosen({
    width: "100%",
  });
  $(".chosen-search-disable-select").chosen({
    width: "100%",
    disable_search_threshold: 10,
  });
});

// $(function () {
//   $(".multiselect-ui-create").multiselect({
//     includeSelectAllOption: false,
//     nonSelectedText: "Categories",
//     disabledText: "Categories",
//     enableClickableOptGroups: true,
//     dropdownName: "categories",
//   });
// });

$(document).on("click", ".delete_icon.last", function () {
  $(".remove-clip-confirm").addClass("hide");
  $(this).parents(".manage-clip").find(".remove-clip-confirm").removeClass("hide");
});
$(document).on("click", ".remove-clip-confirm .btn-cancel", function () {
  $(this).parents(".manage-clip").find(".remove-clip-confirm").addClass("hide");
});
// $(document).on('click', '.clip-movable.state-disabled.last', function() {
// 	$('.clip-toolbar-body .maincontent').removeClass('hide');
// });
// $(document).on('click', '.add-clip-content', function() {
// 	$('.clip-toolbar-body .maincontent').removeClass('hide');
// });
$(document).on("click", ".close-window", function () {
  $(".clip-toolbar-body .maincontent").addClass("hide");
});
$(document).on("click", ".reorder_icon.first", function () {
  $(".clip-reorder-confirm").addClass("hide");
  $(this).parents("li").removeClass("state-disabled");
  $(this).parents(".manage-clip").find(".clip-reorder-confirm").removeClass("hide");
});
$(document).on("click", ".clip-reorder-confirm .btn-cancel", function () {
  $(this).parents("li").addClass("state-disabled");
  $(this).parents(".manage-clip").find(".clip-reorder-confirm").addClass("hide");
});
$(document).on("click", ".clip-reorder-confirm .clip-move-btn", function () {
  $(this).parents(".clip-reorder-confirm").find(".clip-move-section").removeClass("hide");
  $(this).parents(".clips-reorder-drag-section").addClass("hide");
});

$(document).on("click", '.clip-header-check .radio-primary input[type="radio"]', function (event) {
  $(".clip-listing-detail.popluar-clip-image-overlay").css("display", "block");
});
$(document).on("click", ".expand-arrow", function () {
  $(".expand-section").slideToggle();
});
jQuery(document).ready(function ($) {
  var msie6 = $.browser == "msie" && $.browser.version < 7;
  if (!msie6 && $(".sidebar").length > 0 && $(".sidebar").offset() !== null) {
    var height = $(".sidebar").height();
    var winHeight = $(window).height();
    var top = $(".sidebar").offset().top - parseFloat($(".sidebar").css("margin-top").replace(/auto/, 0));
    var footerTop =
      $("footer.main-footer").offset().top - parseFloat($("footer.main-footer").css("margin-top").replace(/auto/, 0));
    var maxY = footerTop - parseFloat($(".sidebar").outerHeight());

    //CalculateSidebar position when page ready(first time)
    calculateSidebarPosition(top, maxY);

    $(window).scroll(function (event) {
      //Recalculate maxY
      var footerTop =
        $("footer.main-footer").offset().top - parseFloat($("footer.main-footer").css("margin-top").replace(/auto/, 0));

      maxY = footerTop - parseFloat($(".sidebar").outerHeight());

      // what the y position of the scroll is
      calculateSidebarPosition(top, maxY);

      if ($("#slider-vertical").length > 0) {
        var maxSliderValue = $(".tbl-of-contnent li").length - 1;

        var items = $(".clip-list-section li.section-title");
        var lastSectionId = "";
        setTimeout(function () {
          items.each(function (key, value) {
            if ($(value).offset().top - 20 > $(window).scrollTop()) {
            } else {
              lastSectionId = $(value).attr("id");
            }
          });

          if (lastSectionId !== "") {
            var selectedIndex = $("a[href='#" + lastSectionId + "']")
              .parent("li")
              .index();
            // jQuery( "#slider-vertical" ).slider( "value", maxSliderValue - selectedIndex );
          } else {
            // jQuery( "#slider-vertical" ).slider( "value", maxSliderValue );
          }
        }, 200);
      }
    });
  }
});

function calculateSidebarPosition(top, maxY) {
  if ($(window).width() >= 767) {
    var y = $(this).scrollTop();

    var sidebar_reading = $(".sidebar").find(".sidebar-reading");

    var calculated_reading_list_min_height = $(window).height() - 236;
    // console.log(calculated_reading_list_min_height);
    if (calculated_reading_list_min_height > $(sidebar_reading).css("min-height")) {
      $(sidebar_reading).css({
        "min-height": calculated_reading_list_min_height,
      });
    }
    // old code
    // $('.sidebar').find('.sidebar-reading').css({
    //     "min-height": ($(window).height() - 236)
    // });
    $(".sidebar")
      .find(".vertical-menu")
      .css({
        "max-height": $(window).height() - ($(".main-footer").height() + 15),
        "overflow-y": "auto",
      });

    if (y > top) {
      if (y < maxY) {
        $(".sidebar").addClass("scrap-book-sidebar-fixed").removeAttr("style");
      } else {
        $(".sidebar")
          .removeClass("scrap-book-sidebar-fixed")
          .css({
            position: "absolute",
            top: maxY - top + 5 + "px",
          });
      }
    } else {
      $(".sidebar").removeClass("scrap-book-sidebar-fixed");
    }

    var sidebar_height = $(".sidebar").height();
    var sidebar_sibling_height = $(".manage-sidebar").next().height();

    if (sidebar_sibling_height < sidebar_height) {
      $(".sidebar").css({
        height: sidebar_sibling_height,
      });
    } else if (sidebar_height > $(window).height() - 46) {
      $(".sidebar").css({
        height: $(window).height() - 46,
      });
    } else {
      $(".sidebar").css({
        height: sidebar_height,
      });
    }
  }
}

jQuery(document).ready(function () {
  jQuery("[data-method]")
    .append(function () {
      var methodForm = "\n";
      methodForm +=
        "<form action='" +
        $(this).attr("href") +
        "' id='" +
        $(this).data("token-1") +
        "' method='POST' style='display:none'>\n";
      methodForm += " <input type='hidden' name='_method' value='" + $(this).attr("data-method") + "'>\n";
      if ($(this).attr("data-token")) {
        methodForm += "<input type='hidden' name='_token' value='" + $(this).attr("data-token") + "'>\n";
      }
      methodForm += "</form>\n";
      return methodForm;
    })
    .removeAttr("href");

  jQuery(".image-overlay-header a[data-method = delete]").on("click", function () {
    if ($(this).hasClass("action_confirm")) {
      var form = this;
      var dynamic_message = $(this).data("name");
      jQuery("#delete-confirmation #dynamic-name").empty().text(dynamic_message);

      jQuery("#delete-confirmation #delete").attr("data-form", jQuery(this).data("token-1")); // Set the delete form id

      jQuery("#delete-confirmation").modal("show");

      // swal({
      //   title: "Are you sure?",
      //   text: "You will not be able to recover this record",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#4DB6AC",
      //   confirmButtonText: "Yes, delete it!",
      //   cancelButtonText: "No, keep it"
      // }).then(result => {
      //   if (result.value) {
      //     // console.log('confirm');
      //     $(form)
      //       .find("form")
      //       .submit();
      //     // For more information about handling dismissals please visit
      //     // https://sweetalert2.github.io/#handling-dismissals
      //   } else if (result.dismiss === swal.DismissReason.cancel) {
      //   }
      // });
    }
  });
});

jQuery(document).on("click", "#delete-confirmation #delete", function (e) {
  e.preventDefault();
  jQuery(`form#${jQuery(this).data("form")}`).submit();
});

$.imageChanger = function (input, site, default_img) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $("#" + site).css("visibility", "visible");
      if (input.files[0].type == "application/pdf") {
        $("#" + site).attr("src", "/uploads/default/100x100/pdfIcon.jpg");
      } else {
        $("#" + site).attr("src", e.target.result);
      }
      if (default_img) {
        $("#" + default_img).remove();
      }
    };
    reader.readAsDataURL(input.files[0]);
  }
};
/* Function Used In Set Error in Modal */
function associate_errors(errors, $form) {
  //remove existing error classes and error messages from form groups
  $form.find(".form-group").removeClass("has-error").find(".help-block").text("");
  jQuery("form").find(".help-block").text("");
  jQuery.each(errors, function (index, value) {
    //find each form group, which is given a unique id based on the form field's name
    var $group = $form.find("#" + index).parents(".form-group");
    if ($group.addClass("has-error").find(".help-block").length === 0) {
      $group.find(".form-control").parent("div").append("<span class='help-block'></span>");
    }
    //add the error class and set the error text
    $group.addClass("has-error").find(".help-block").text(value);
  });
}

$(function () {
  if ($("#slider-vertical").length > 0) {
    var maxSliderValue = $(".tbl-of-contnent li").length - 1;
    var sidebarHeight = $(".tbl-of-contnent").height() - 22;
    $("#slider-vertical").css({
      height: sidebarHeight + "px",
    });
    // $( "#slider-vertical" ).slider({
    // 	orientation: "vertical",
    // 	range: "min",
    // 	animate: "slow",
    // 	min: 0,
    // 	step: 1,
    // 	max: maxSliderValue,
    // 	value: 60,
    // 	stop: function( event, ui ) {
    // 		var currentValue = maxSliderValue - ui.value;
    // 		$(".tbl-of-contnent li").eq(currentValue).children('a').click();
    // 	}
    // });
  }
});

// $(document).ready(function(){
// 	if (".watch-video-modal").close(){
// 		console.log(1);
// 		$('.watch-video-modal iframe').css({
// 				autoplay=0;
// 			});
// 	}
// });
jQuery(document).ready(function ($) {
  var videoSrc = $("#myModal-donate-page iframe").attr("src");

  $("#myModal-donate-page").on("show.bs.modal", function () {
    $("#myModal-donate-page iframe").attr("src", videoSrc + "&amp;autoplay=1");
  });
  $("#myModal-donate-page").on("hidden.bs.modal", function (e) {
    // on closing the modal
    // stop the video
    $("#myModal-donate-page iframe").attr("src", videoSrc + "&amp;autoplay=0");
  });
});

jQuery(document).ready(function ($) {
  var videoSrc = $(".donate-front #myModal iframe").attr("src");
  $(".donate-front #myModal").on("hidden.bs.modal", function (e) {
    // on closing the modal
    // stop the video
    $(".donate-front #myModal iframe").attr("src", videoSrc + "&amp;autoplay=0");
  });
});
jQuery(document).ready(function ($) {
  var videoSrc = $(".header-background-image #myModal iframe").attr("src");
  $(".header-background-image #myModal").on("hidden.bs.modal", function (e) {
    // on closing the modal
    // stop the video
    $(".header-background-image #myModal iframe").attr("src", videoSrc + "&amp;autoplay=0");
  });
});
$(".download-modal-link").click(function (e) {
  e.preventDefault();
  $("#downloadModal").modal("show");
  $(this).blur();
  return false;
});

$(".membership_signup").click(function () {
  $(".donate-info .join-donate-info").addClass("hide");
  $(".donately-membership-type select").val($(this).data("plan")).trigger("change");
  // $('.donately-donation-form #donately-amount').val($(this).data("plan"));

  $("html,body").animate(
    {
      scrollTop: $(".donate-info .donate-main-form").addClass("show").offset().top,
    },
    1000
  );
});

$(".type-button").click(function () {
  $(".donate-info .join-donate-info").addClass("hide");
  $(".donate-info .donate-main-form").addClass("show");
  $(".donately-membership-type select").val($(this).data("plan"));
  $(".donately-donation-form #donately-amount").val($(this).data("plan"));
});
$(".btn_submit").submit(function () {
  $(".donate-info .donate-main-form").addClass("hide");
  $(".donate-info .donate-thankyou-form").addClass("show");
});

// $('.type-button').click(function (e){
// 	$('.join-donate-info').addClass('hide');
// 	$('.donate-main-form').removeClass('hide');
// });

// $('.download-modal-link').click(function (e){
// 	console.log(1);
// 	$('.modal-backdrop fade in').css('display','none');
// });

jQuery(".download-file").on("click", function (e) {
  setTimeout(() => {
    callFacebookPixelTrackAjax([]); //Call ajax for fb pixel track
  }, 1000);
});

jQuery(document).on("submit", "form#loginForm, form#registerForm", function (e) {
  jQuery(this).find(".loader-ajax").show();
});

jQuery(document).on("click", ".mark-notification-read", function (e) {
  e.preventDefault();
  var url = jQuery(this).attr("href");
  console.log(url);
  axios.post(url).then(function (response) {
    window.location.reload();
  });
});

/* Start: Donate form related juery*/
jQuery("#donately-popup-form , .campain-form form.donately-donation-form").on("submit", function (e) {
  e.preventDefault();
  let amount = parseFloat(jQuery(this).find(`input[name="amount"]`).val() || 0);
  let final_amount = parseFloat(jQuery(this).find(`input[name="final_amount"]`).val() || 0);

  if (!final_amount) {
    jQuery(this)
      .find(`input[name="amount"]`)
      .parent()
      .append(`<div class="error" id="amount_err"> Invalid amount. Please select/enter other amount.</div>`);
    return false;
  }

  jQuery(this).find(".donately-submit").attr("disabled", "disabled");
  var data = jQuery(this).serialize();
  var url = window.location.href;
  data += "&metadata[url]=" + url;
  data += "&metadata[title]=" + document.title;
  data += "&back_url=" + url;

  // data = data+"&donation_page_design=old_donate_page"
  jQuery("#loader-ajax").show();
  donateAjax(data, url); // Call the payment function
  // callFacebookPixelTrackAjax({
  //   back_url: url
  // }); //Call ajax for fb pixel track
});

jQuery("#donately-popup-form-new-flow").on("submit", function (e) {
  e.preventDefault();
  let final_amount = parseFloat(jQuery(this).find(`input[name="final_amount"]`).val() || 0);

  if (!final_amount) {
    return false;
  }

  jQuery("#btn_donation_step_two_submit").attr("disabled", "disabled");

  var data = jQuery(this).serialize();
  // data = data+"&donation_page_design=new_donate_page"
  jQuery("#loader-ajax-new-flow").removeClass("hide");
  donateAjaxNewFlow(data); // Call the payment function
});

jQuery("#copy-link").on("click", function (e) {
  /* Get the text field */
  var copyText = document.getElementById("view_link");

  /* Select the text field */
  copyText.select();

  /* Copy the text inside the text field */
  document.execCommand("Copy");

  $(this).val("Copied");
});

// send the form data for payment
function donateAjaxNewFlow(data) {
  axios
    .post("/donate", data)
    .then(function (response) {
      jQuery("#btn_donation_step_two_submit").removeAttr("disabled");

      if (response.data.error) {
        PNotify.alert({
          text: response.data.error.message,
          type: "error",
          styling: "bootstrap4",
          icon: false,
        });
        // alert(response.data.error.message);
        jQuery("#loader-ajax-new-flow").addClass("hide");
      } else {
        // display thank you pop up
        jQuery("#loader-ajax-new-flow").addClass("hide");
        jQuery("#new-donation-flow-form").modal("hide");
        // jQuery("#new-donation-flow-form-thank-you").modal("show");
        var url = document.location.href;
        if (url.includes("?")) {
          url =
            document.location.href +
            "&transaction_id=" +
            response.data.id +
            "&order=" +
            response.data.amount +
            "&receipt_sigma=" +
            response.data.receipt_email;
        } else {
          url =
            document.location.href +
            "?transaction_id=" +
            response.data.id +
            "&order=" +
            response.data.amount +
            "&receipt_sigma=" +
            response.data.receipt_email;
        }
        document.location = url;
      }
    })
    .catch(function (error) {
      PNotify.alert({
        text: error.response.data.message,
        type: "error",
        styling: "bootstrap4",
        icon: false,
      });
      // console.log(error);
      // alert(error.response.data.message);
      jQuery("#loader-ajax-new-flow").addClass("hide");
    });
}

// send the form data for payment
function donateAjax(data, back_url) {
  $("#loader-ajax").removeClass("hide");
  axios
    .post(route("user.donate"), data)
    .then(function (response) {
      jQuery(".donately-submit").removeAttr("disabled");

      if (response.data.error) {
        PNotify.alert({
          text: response.data.error.message,
          type: "error",
          styling: "bootstrap4",
          icon: false,
        });
        // alert(response.data.error.message);
        jQuery("#loader-ajax").hide();
      } else {
        if (data.indexOf("form_location") >= 0) {
          jQuery(".donate-main-form").removeClass("show");
          jQuery(".donate-main-form").addClass("hide");
          jQuery(".donate-thankyou-form").removeClass("hide");
        } else {
          jQuery("#donately-popup-form").hide();
          jQuery(".after-donate-message-text").show();
        }
        $("#loader-ajax").addClass("hide");
        window.location.href = "/thankyou-for-donation?back_url=" + back_url;
      }
    })
    .catch(function (error) {
      PNotify.alert({
        text: error.response.data.message,
        type: "error",
        styling: "bootstrap4",
        icon: false,
      });
      console.log(error);
      alert(error.response.data.message);
      $("#loader-ajax").addClass("hide");
    });
}
/* End: Donate form related juery*/

/* Start: shared counter update jquery for book/clip */

jQuery(document).on("click", ".clip-share .modal-social-share .share-this", function (e) {
  var source = $(this).attr("id").split("-");
  var clip_id = source[1];
  var share_type = source[0];

  var url = "/clip/" + clip_id + "/share";
  var data = {
    share_type: share_type,
  };

  //fire ajax for udpate the shared counter
  updateShareCounterAjax(url, data);
});

jQuery(document).on("click", ".book-share .modal-social-share .share-this", function (e) {
  var source = $(this).attr("id").split("-");
  var book_id = source[1];
  var share_type = source[0];

  var url = "/book/" + book_id + "/share";
  var data = {
    share_type: share_type,
  };

  //fire ajax for udpate the shared counter
  updateShareCounterAjax(url, data);
});

//Update shared counter when the page data is shared in social media
function updateShareCounterAjax(url, data) {
  axios
    .post(url, data)
    .then(function (response) {})
    .catch(function (error) {});
}

/* End: shared counter update jquery for book/clip */

function callFacebookPixelTrackAjax(data) {
  axios
    .post(route("fb.pixel.track"), data)
    .then(function (response) {})
    .catch(function (error) {});
}

//Multi select code start here
(function ($) {
  $(document).ready(function () {
    $(".custom-multi-choice .ms-drop").hide();
    $(".custom-multi-choice .ms-choice").click(function () {
      $(this).parents(".ms-parent").find(".ms-drop").toggle();
      if ($(this).parents(".ms-parent").find(".ms-drop").is(":hidden")) {
        $(this).find(".placeholder").next().removeClass("open");
      } else {
        $(".ms-drop").hide();
        $(".ms-choice").find(".placeholder").next().removeClass("open");
        $(this).find(".placeholder").next().addClass("open");
        $(this).parents(".ms-parent").find(".ms-drop").show();
      }
    });
    $('.custom-multi-choice .optgroup input[type="checkbox"]').click(function () {
      // var sub_checkboxes = $(this)
      //   .parent()
      //   .next();
      // if ($(this).prop("checked")) {
      //   sub_checkboxes.slideDown();
      // } else {
      //   sub_checkboxes.slideUp();
      //   sub_checkboxes.find('input[type="checkbox"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
      // }
    });
    $(".custom-multi-choice .ms-drop ul li.group").each(function () {
      // $(this).find(".sub").show();
      // if (
      //   $(this).find('.optgroup input[type="checkbox"]').prop("checked")
      // ) {
      //   $(this).find(".sub").show();
      // }
      // $(this).find('.sub li input[type="checkbox"]').each(function() {
      //     if ($(this).prop("checked")) {
      //       $(this)
      //         .parents(".sub")
      //         .show();
      //       $(this)
      //         .parents(".group")
      //         .find('.optgroup input[type="checkbox"]')
      //         .prop("checked", true);
      //     }
      //   });
    });

    $(document).click(function (e) {
      if (!$(e.target).parents(".ms-parent").hasClass("ms-parent")) {
        $(".ms-drop").hide();
        $(".custom-multi-choice .ms-choice").find(".placeholder").next().removeClass("open");
      }
    });

    $.fn.tagSelected = function (current, form_id) {
      var form_id = current.parents("form").attr("id");
      var element_id = current.attr("id");
      var placeholder_text = current.parents(".ms-parent").find(".placeholder").text();
      if (current.prop("checked")) {
        if (current.parent().find(".main-title").length != 0) {
          var title = current.parent().find(".main-title").text().trim();
          if (form_id == "searchFilter" || form_id == "sortFilter") {
            addLabelText(element_id, title);
          }
        } else {
          var title = current.parent().text().trim();
          if (form_id == "searchFilter" || form_id == "sortFilter") {
            addLabelText(element_id, title);
          }
        }
      } else {
        if (form_id == "searchFilter" || form_id == "sortFilter") {
          $(`.${element_id}`).remove();
        }
      }
      if ($(".tags").length == 0) {
        $(".tags-clear").remove();
      }
    };

    $("body").on("click", '.custom-multi-choice .ms-drop input[type="checkbox"]', function () {
      $.fn.tagSelected($(this));
    });

    $('.custom-multi-choice .ms-drop input[type="checkbox"]').each(function () {
      $.fn.tagSelected($(this));
    });
  });
})(jQuery);
//Multi select code ends here

function addLabelText(element_id, title) {
  $(".tags-clear").remove();
  $(".filter-tags").append(
    '<span class="tags ' +
      element_id +
      '"><span class="txt">' +
      title +
      '</span> <a class="cancel-element" data-element="' +
      element_id +
      '" href="#">x</a></span>'
  );
  $(".filter-tags").append('<span class="tags-clear clear-all"><a href="#"><span class="txt">Clear</span></a></span>');
}

//auto play youtube video
function autoPlayYouTubeModal() {
  var trigger = $(".cotnent-footer-btn , .vision-content").find('[data-toggle="modal"]');
  trigger.click(function () {
    var theModal = $(this).data("target"),
      videoSRC = $(this).attr("data-theVideo"),
      videoSRCauto = videoSRC + "?autoplay=1";
    $(theModal + " iframe").attr("src", videoSRCauto);
    $(theModal + " button.close").click(function () {
      $(theModal + " iframe").attr("src", videoSRC);
    });
  });
}
autoPlayYouTubeModal();

$(document).ready(function () {
  $(".modal-social-share a").attr("target", "_blank");
  $(".view-donor .new-book").click(function () {
    $(".view-donor").addClass("hide");
    $(".donate-our-donor").removeClass("hide");
  });
  $(".donate-our-donor .close").click(function () {
    $(".view-donor").removeClass("hide");
    $(".donate-our-donor").addClass("hide");
  });

  // $( "form" ).each(function( index ) {
  // 	var form = $(this);
  // 	console.log(form.attr('id'));
  // 	var loader_element = '<div class="loader-ajax" style="display:none;"></div>';
  // 	// console.log(form.find('.loader-ajax').length);
  // 	if(form.find('.loader-ajax').length == 0){
  // 		form.find('[type="submit"]').after(loader_element);
  // 	}
  // });

  $(".form-item-description textarea").keyup(function () {
    var max = $(this).attr("maxlength");
    var len = $(this).val();
    var textLength = $(this).val().length;
    var newLines = len.match(/(\r\n|\n|\r)/g);
    var val = $(this).val();
    var newlineLength = 0;

    if (newLines != null) {
      newlineLength = newLines.length;
    }
    var totalLength = textLength + newlineLength;
    if (totalLength >= max) {
      $(this).val(val.substring(0, max));
    }
    var char = max - totalLength;
    console.log(max);
    $(this).parent().find(".char-left").text(char);
  });
});

window.getBlogImageList = function () {
  var img_src = [];
  var img_alt = [];
  jQuery(".blog-content img").each(function (index, value) {
    img_src.push(jQuery(value).attr("src"));
    img_alt.push(jQuery(value).attr("alt"));
  });
  console.log("Iamge Src:");
  jQuery.each(img_src, function (index, value) {
    console.log(value);
  });
  console.log("\n Image Alt:");
  jQuery.each(img_alt, function (index, value) {
    console.log(value);
  });
};

window.route = (name, args) => {
  if (_.has(routes, name)) {
    let value = _.get(routes, name, name);
    _.forEach(args, (paramVal, paramKey) => {
      value = _.replace(value, `{${paramKey}}`, paramVal);
    });
    if (value.charAt(0) !== "/") {
      value = "/" + value;
    }
    return value;
  }
  return "";
};

jQuery(document).on("click", ".popluar-clip-content-wrapper.video", function (event) {
  var element = event.target.nodeName;
  var detect_element_list = ["IMG", "I"];
  var class_list = [];
  class_list["I"] = "fa-youtube-play";
  class_list["IMG"] = "clip-image";

  if (
    jQuery.inArray(element, detect_element_list) >= 0 &&
    jQuery.inArray(class_list[element], event.target.classList) >= 0
  ) {
    event.preventDefault();
    var content = $(this).find(".video-play-button").data("content");
    $("#video-model").find(".modal-body .content").append(content);
    setTimeout(() => {
      $("#video-model").modal("show");
    }, 500);
  }
});
$("#video-model").on("hidden.bs.modal", function (e) {
  // on closing the modal
  // stop the video
  $("#video-model .modal-body .content").empty();
});

window.checkDeviceType = function () {
  // https://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device
  if (/Android|webOS|iPhone|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return "mobile";
  } else {
    return "desktop";
  }
};
